import React from 'react'
import './App.css';
import {Routes, Route } from 'react-router-dom'
import {Provider as AppProvider} from './contexts/App'
import {Provider as SalesChannelsProvider} from './contexts/SalesChannels'
import {Provider as NotificationsProvider} from './contexts/Notifications'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ThemeProvider } from '@mui/material/styles';
import getTheme from './theme'

import CircularProgress from "@mui/material/CircularProgress"
import AppRoutes from './public/AppRoutes'
import Login from './public/Login'
import Bundles from './pages/Bundles'
import Clients from './pages/Clients'
import Suppliers from './pages/Suppliers'

import Stores from './pages/Stores'
import Navigation from './pages/Navigation'
import Listings from './pages/Listings'
import Liquidations from './pages/Liquidations'
import Requisitions from './pages/Requisitions'
import Currencies from './pages/Currencies'
import Products from './pages/Products'
import Inventories from './pages/Inventories'
import InventoryCapital from './pages/InventoryCapital'
import Warehouses from './pages/Warehouses'
import SalesChannelShippments from './pages/SalesChannelShippments'
import Events from './pages/Events'
import ExternalWarehousingCosts from './pages/ExternalWarehousingCosts'
import Guides from './pages/Guides'
import StockCosts from './pages/StockCosts'
import ExtraCosts from './pages/ExtraCosts'
import PublicityCampaigns from './pages/PublicityCampaigns'
import ProductPublicities from './pages/ProductPublicities'
import ProductMetrics from './pages/Metrics/ProductMetrics'
import SalesChannelMetrics from './pages/Metrics/SalesChannelMetrics'

import BulkUpdateProducts from './pages/BulkUpdateProducts/update-bulk'
import {Context as AuthContext} from './contexts/Auth'
import {Context as StoreContext} from './contexts/Store'
import StoreList from './pages/Stores/list';
import PlatformCostCalculations from './pages/PlatformCostCalculations';
import PlatformStatuses from './pages/PlatformStatuses';

function App() {
  const Loader = <CircularProgress size={50}/>
  const {auth, loading: authLoading} = React.useContext(AuthContext)
  const {store, loading: storeLoading} = React.useContext(StoreContext)
  console.log({auth , store, authLoading, storeLoading})
  return (
    <ThemeProvider theme={getTheme(store?store.color:"#CACACA")}>
    {authLoading?
      <CircularProgress></CircularProgress>
      :auth?
        storeLoading?
          <CircularProgress></CircularProgress>
          :store?
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              
                <Routes>
                  <Route path="*" element={ <AppRoutes.PrivateRoute component={<Navigation/>} Loader={Loader}/> }>
                  </Route>
                </Routes>
                <NotificationsProvider>
                  <AppProvider>
                      <React.StrictMode>
                          <Routes>
                            <Route path="/stores" element={ <AppRoutes.PrivateRoute component={<StoreList/>} Loader={Loader}/> }/>
                            <Route path="/products" element={ <AppRoutes.PrivateRoute component={<Products/>} Loader={Loader}/> }/>
                            <Route path="/inventories" element={ <AppRoutes.PrivateRoute component={<Inventories/>} Loader={Loader}/> }/>
                            <Route path="/invenotriesCapital" element={ <AppRoutes.PrivateRoute component={<InventoryCapital/>} Loader={Loader}/> }/>
                            <Route path="/warehouses" element={ <AppRoutes.PrivateRoute component={<Warehouses/>} Loader={Loader}/> }/>
                            <Route path="/update-products" element={ <AppRoutes.PrivateRoute component={<BulkUpdateProducts/>} Loader={Loader}/> }/>
                            <Route path="/currencies" element={ <AppRoutes.PrivateRoute component={<Currencies/>} Loader={Loader}/> }/>
                            <Route path="/bundles" element={ <AppRoutes.PrivateRoute component={<Bundles/>} Loader={Loader}/> }/>
                            <Route path="/platformcostcalculations" element={ <AppRoutes.PrivateRoute component={<PlatformCostCalculations/>} Loader={Loader}/> }/>
                            <Route path="/platformstatuses" element={ <AppRoutes.PrivateRoute component={<PlatformStatuses/>} Loader={Loader}/> }/>
                            <Route path="/suppliers" element={ <AppRoutes.PrivateRoute component={<Suppliers/>} Loader={Loader}/> }/>
                            <Route path="/clients" element={ <AppRoutes.PrivateRoute component={<Clients/>} Loader={Loader}/> }/>
                            <Route path="/productMetrics" element={ <AppRoutes.PrivateRoute component={<ProductMetrics/>} Loader={Loader}/> }/>
                            <Route path="/salesChannelMetrics" element={ <AppRoutes.PrivateRoute component={<SalesChannelMetrics/>} Loader={Loader}/> }/>
                          </Routes>
                        </React.StrictMode>
                        <SalesChannelsProvider>
                          <React.StrictMode>
                            <Routes>
                              <Route path="/salesChannelShippment" element={ <AppRoutes.PrivateRoute component={<SalesChannelShippments/>} Loader={Loader}/> }/>
                              <Route path="/listings" element={ <AppRoutes.PrivateRoute component={<Listings/>} Loader={Loader}/> }/>
                              <Route path="/liquidations" element={ <AppRoutes.PrivateRoute component={<Liquidations/>} Loader={Loader}/> }/>
                              <Route path="/requisitions" element={ <AppRoutes.PrivateRoute component={<Requisitions/>} Loader={Loader}/> }/>
                              <Route path="/events" element={ <AppRoutes.PrivateRoute component={<Events/>} Loader={Loader}/> }/>
                              <Route path="/externalwarehousing" element={ <AppRoutes.PrivateRoute component={<ExternalWarehousingCosts/>} Loader={Loader}/> }/>
                              <Route path="/guides" element={ <AppRoutes.PrivateRoute component={<Guides/>} Loader={Loader}/> }/>
                              <Route path="/fba" element={ <AppRoutes.PrivateRoute component={<StockCosts/>} Loader={Loader}/> }/>
                              <Route path="/costs" element={ <AppRoutes.PrivateRoute component={<ExtraCosts/>} Loader={Loader}/> }/>
                              <Route path="/campaigns" element={ <AppRoutes.PrivateRoute component={<PublicityCampaigns/>} Loader={Loader}/> }/>
                              <Route path="/productPublicities" element={ <AppRoutes.PrivateRoute component={<ProductPublicities/>} Loader={Loader}/> }/>
                            </Routes>
                          </React.StrictMode>
                        </SalesChannelsProvider>
                  </AppProvider>
                </NotificationsProvider>
            </LocalizationProvider>
        :<Routes>
          <Route path="*" element={<Stores/>}/>
        </Routes>
      :<Routes>
          <Route path="*" element={<Login/>}/>
      </Routes>
    }
    </ThemeProvider>
  );
}

export default App;